import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";

const ModalContext = createContext();

export const useModalContext = () => useContext(ModalContext);

export const ModalContextProvider = ({ children, showNonHistoriedDialog, closeDialog, destinationUrl }) => {
  return (
    <ModalContext.Provider value={{ showNonHistoriedDialog, destinationUrl, closeDialog }}>
      {children}
    </ModalContext.Provider>
  );
};

ModalContextProvider.propTypes = {
  children: PropTypes.node,
  showNonHistoriedDialog: PropTypes.func,
  destinationUrl: PropTypes.func,
  closeDialog: PropTypes.func
};
